import React from 'react';
import { Icon } from './Icon.js';
export const IconCalendarBolt = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M17.2363 16H22.2363L19.2363 22H17L19 18H14L17 12H19.2363L17.2363 16Z", fill: "currentColor", "data-stroke": "none" }),
        React.createElement("path", { d: "M7 4V2", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M17 4V2", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M3 9H21", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M22 10H20V5H4V20H13L12 22H2V3H22V10Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconCalendarBolt.js.map